/*global Modernizr */
/*jslint browser:true */

(function() {
  'use strict';

  document.querySelector('body').addEventListener('click', (e) => {
    close_all_open_items();
  }, {passive: true});

  var dropdown_nav_containers = document.querySelectorAll('.nav-container, .section-nav');

  dropdown_nav_containers.forEach((nav_container) => {
    var has_children = nav_container.querySelectorAll('.menu-item-has-children');

    if(has_children) {
      has_children.forEach((menu_item) => {
        var anchor_container = menu_item.firstElementChild,
            menu_item_link = anchor_container.firstElementChild,
            menu_item_button = menu_item_link.nextElementSibling,
            sub_menu_container = menu_item.querySelector(':scope > .sub-menu-container'),
            menu_item_list = sub_menu_container.querySelector('ul'),
            timer;

        menu_item.addEventListener('click', (e) => {
          e.stopPropagation();
        });

        if(menu_item_list) {
          // Don't send touch event further than the link
          menu_item_link.addEventListener('touchstart', (e) => {
            e.stopPropagation();
          }, { passive: true });

          // Allow top level nav to open sub nav on mobile
          menu_item_link.addEventListener('click', (e) => {
            if(document.body.classList.contains('mobile-menu-open')) {
              e.stopPropagation();
              e.preventDefault();

              if(menu_item.classList.contains('open')) {
                menu_item.classList.remove('open');
                menu_item.classList.remove('focus-open');
              } else {
                menu_item.classList.add('open');
              }
            } else if(menu_item_link.nodeName === 'BUTTON') {
              if(menu_item.classList.contains('open')) {
                menu_item.classList.remove('open');
                menu_item.classList.remove('focus-open');
                menu_item_button.setAttribute('aria-expanded', 'false');
              } else {
                menu_item.classList.add('open');
                menu_item_button.setAttribute('aria-expanded', 'true');

                setTimeout(function(){
                  var anchors = menu_item.querySelector('.sub-menu-container').querySelectorAll('ul a'),
                      select_anchor = anchors[0];

                  if(select_anchor.parentNode.classList.contains('menu-item-overview')) {
                    select_anchor = anchors[1];
                  }

                  if(select_anchor) {
                    select_anchor.focus();
                  } else {
                    menu_item.querySelector('.sub-menu-container').focus();
                  }
                }, 350);
              }
            }
          });

          if(menu_item_button) {
            if(menu_item_link.getAttribute('href') !== '#') {
              var menu_item_depth = 0;

              for (const className of menu_item_link.classList) {
                if(className.substring(0, 16) === 'menu-item-depth-') {
                  menu_item_depth = parseInt(className.substring(16)) + 1;
                  break;
                }
              }

              var overview_item = document.createElement('li');
              overview_item.classList.add('menu-item', 'menu-item-depth-' + menu_item_depth, 'menu-item-overview');

              var overview_item_link_container = document.createElement('div');
              overview_item_link_container.classList.add('anchor-container', 'menu-item-depth-' + menu_item_depth);

              var overview_item_link = document.createElement('a');
              overview_item_link.classList.add('menu-anchor', 'menu-item-depth-' + menu_item_depth);
              overview_item_link.setAttribute('tabindex', '-1');
              overview_item_link.innerText = 'Overview';

              if(menu_item_link.nodeName === 'BUTTON') {
                overview_item_link.setAttribute('href', '/');
              } else {
                overview_item_link.setAttribute('href', menu_item_link.getAttribute('href'));
              }

              if(location.href === menu_item_link.getAttribute('href')) {
                overview_item_link.setAttribute('aria-current', 'page');

                overview_item.classList.add('current-menu-item');
              }

              overview_item_link_container.appendChild(overview_item_link);
              overview_item.appendChild(overview_item_link_container);

              menu_item_list.insertBefore(overview_item, menu_item_list.firstChild);
            }

            // Set aria expanded on mouse enter
            menu_item.addEventListener('mouseenter', (e) => {
              menu_item_button.setAttribute('aria-expanded', 'true');
            });

            // Remove aria expanded on mouse out
            menu_item.addEventListener('mouseleave', (e) => {
              menu_item_button.setAttribute('aria-expanded', 'false');
            });

            menu_item_button.addEventListener('touchstart', (e) => {
              e.stopPropagation();

              if(e.cancelable) {
                e.preventDefault();

                var dropdown = menu_item.querySelector(':scope > .sub-menu-container');

                if(menu_item.classList.contains('open')) {
                  menu_item.classList.remove('open');
                  menu_item.classList.remove('focus-open');
                  menu_item_button.setAttribute('aria-expanded', 'false');
                } else {
                  menu_item.classList.add('open');
                  menu_item_button.setAttribute('aria-expanded', 'true');
                }
              }
            }, {passive: false});

            // Allow keyboard to open mobile menu
            menu_item_button.addEventListener('keydown', (e) => {
              // Open menu with enter, space, up, or down arrow
              if(e.key === 'Enter' || e.key === 'Space' || e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                e.preventDefault();

                var dropdown = menu_item.querySelector(':scope > .sub-menu-container');

                if(menu_item.classList.contains('open')) {
                  menu_item.classList.remove('open');
                  menu_item.classList.remove('focus-open');
                  menu_item_button.setAttribute('aria-expanded', 'false');
                } else {
                  close_all_open_items();

                  menu_item.classList.add('open');
                  menu_item.classList.add('focus-open');
                  menu_item_button.setAttribute('aria-expanded', 'true');

                  setTimeout(function(){
                    var anchors = Array.from(menu_item.querySelectorAll('ul .menu-item'));

                    anchors = anchors.filter(anchor => {
                      return !anchor.classList.contains('menu-item-overview');
                    }).map(anchor => {
                      return anchor.querySelector('a');
                    });

                    var select_anchor = anchors[0];

                    if(e.key === 'ArrowUp') {
                      select_anchor = anchors[anchors.length - 1];
                    }

                    if(select_anchor) {
                      select_anchor.focus();
                    } else {
                      menu_item.querySelector('.sub-menu-container').focus();
                    }
                  }, 350);
                }
              }
            });

            menu_item_button.addEventListener('click', (e) => {
              e.stopPropagation();

              if(document.body.classList.contains('mobile-menu-open')) {
                e.preventDefault();
                menu_item.classList.toggle('open');
              } else {
                if(menu_item.classList.contains('open')) {
                  menu_item.classList.remove('open');
                  menu_item.classList.remove('focus-open');
                  menu_item_button.setAttribute('aria-expanded', 'false');
                } else {
                  close_all_open_items();

                  menu_item.classList.add('open');
                  menu_item_button.setAttribute('aria-expanded', 'true');

                  setTimeout(function(){
                    var anchors = menu_item.querySelector('.sub-menu-container').querySelectorAll('ul a:not(.overview-link)'),
                        select_anchor = anchors[0];

                    if(select_anchor) {
                      select_anchor.focus();
                    } else {
                      menu_item_link.parentNode.querySelector('.sub-menu-container').focus();
                    }
                  }, 350);
                }
              }
            });
          }
        }

        if(sub_menu_container) {
          var sub_menu_container_close = sub_menu_container.querySelector('.anchor-close');

          // Don't send touch event further than the container
          sub_menu_container.addEventListener('touchstart', (e) => {
              e.stopPropagation();
          }, { passive: true });

          sub_menu_container.addEventListener('keydown', (e) => {
            var anchors = Array.from(sub_menu_container.querySelectorAll(':scope > ul > li > .anchor-container a:not(.overview-link)'));

            if(anchors[0].parentNode.parentNode.classList.contains('menu-item-overview')) {
              anchors.splice(0, 1);
            }

            var current_anchor_index = anchors.indexOf(e.target);

            // On key escape
            if(e.key === 'Escape') {
              e.preventDefault();
              sub_menu_container.parentNode.classList.remove('open');
              sub_menu_container.previousElementSibling.querySelector('button').setAttribute('aria-expanded', 'false');
              sub_menu_container.previousElementSibling.querySelector('button').focus();
            }

            // On key up
            if(e.key === 'ArrowUp') {
              e.preventDefault();

              if(current_anchor_index === 0) {
                anchors[anchors.length - 1].focus();
              } else {
                anchors[current_anchor_index - 1].focus();
              }
            }

            // On key down
            if(e.key === 'ArrowDown') {
              e.preventDefault();

              if(current_anchor_index === (anchors.length - 1)) {
                anchors[0].focus();
              } else {
                anchors[current_anchor_index + 1].focus();
              }
            }

            // Key home, go to first anchor
            if(e.key === 'Home') {
              e.preventDefault();
              anchors[0].focus();
            }

            // Key end, go to last anchor
            if(e.key === 'End') {
              e.preventDefault();
              anchors[anchors.length - 1].focus();
            }
          });

          // Clear out timer if focus still in subnav.
          sub_menu_container.addEventListener('focusin', function(event){
            if (timer) {
              clearTimeout(timer);
              timer = null;
            }
          });

          // Set timer if focus leaves the subnav. This triggers even if you are tabbing within the subnav.
          sub_menu_container.addEventListener('focusout', function(event){
            var open_menu_item = nav_container.querySelector(".menu-item-has-children.open");

            if(!open_menu_item || !open_menu_item.classList.contains('focus-open')) {
              return;
            }

            timer = setTimeout(function(event){
              if(open_menu_item && !document.body.classList.contains('mobile-menu-open')) {
                open_menu_item.classList.remove('open');
                open_menu_item.querySelector('[aria-haspopup]').setAttribute('aria-expanded', 'false');
              }
            }, 20);
          });

          if(sub_menu_container_close) {
            sub_menu_container_close.addEventListener('click', (e) => {
              e.preventDefault();

              sub_menu_container.parentNode.classList.remove('open');
              sub_menu_container.previousElementSibling.querySelector('button').setAttribute('aria-expanded', 'false');
              sub_menu_container.previousElementSibling.querySelector('button').focus();
            });
          }
        }
      });
    }
  });

  var mobile_menu_trigger = document.querySelector('.mobile-menu-trigger');
  if(mobile_menu_trigger) {
    mobile_menu_trigger.addEventListener('click', (e) => {
      e.preventDefault();

      const openMenu = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        document.body.classList.toggle('mobile-menu-open');
      };

      // Fallback for browsers that don't support View Transitions:
      if (!document.startViewTransition) {
        openMenu();
      } else {
        document.startViewTransition(() => openMenu());
      }
    });
  }

  var mobile_menu_close = document.getElementById('mobile-nav-close');
  if(mobile_menu_close) {
    mobile_menu_close.addEventListener('click', (e) => {
      e.preventDefault();

      const closeMenu = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        document.body.classList.remove('mobile-menu-open');

        var open_items = document.querySelectorAll('.nav-container .menu-item.open, .section-nav .menu-item.open');

        if(open_items) {
          open_items.forEach((open_item) => {
            var anchor_container = open_item.firstElementChild,
                menu_item_link = anchor_container.firstElementChild,
                menu_item_button = menu_item_link.nextElementSibling;

            open_item.classList.remove('open');
            open_item.classList.remove('focus-open');
            menu_item_button.setAttribute('aria-expanded', 'false');
          });
        }
      };

      // Fallback for browsers that don't support View Transitions:
      if (!document.startViewTransition) {
        closeMenu();
      } else {
        document.startViewTransition(() => closeMenu());
      }
    });
  }

  function close_all_open_items() {
    var open_items = document.querySelectorAll('.nav-container .menu-item.open, .section-nav .menu-item.open');

    if(open_items) {
      open_items.forEach((open_item) => {
        var anchor_container = open_item.firstElementChild,
            menu_item_link = anchor_container.firstElementChild,
            menu_item_button = menu_item_link.nextElementSibling;

        open_item.classList.remove('open');
        open_item.classList.remove('focus-open');
        menu_item_button.setAttribute('aria-expanded', 'false');
      });
    }
  }
}());